export default __webpack_public_path__ + "static/media/gallery_02.dd4cc856.jpg";